import { TabTagType } from "#resources/helpers/tabs";
import classNames from "classnames";
import * as React from "react";
import s from "./icon.scss";
import { ICON_NAMES } from "./constants";

interface Props extends React.SVGProps<SVGElement> {
	icon: IconName;
	className?: string;
	style?: React.CSSProperties;
	tagType?: TabTagType;
	rotate?: number;
}

export type IconName = typeof ICON_NAMES[number];

// debito técnico: move this to svgr and get icon types by icons file name

const MAX_ROTATE = 360;

// Cache por nome: React.lazy cria um "tipo" novo a cada chamada, então
// chamá-lo dentro do render fazia o Suspense desmontar e resuspender o icone
// (fallback "-" piscando) a cada re-render do componente pai.
const iconComponentCache = new Map<IconName, React.ComponentType<any>>();

function getIconComponent(icon: IconName) {
	let Component = iconComponentCache.get(icon);
	if (!Component) {
		Component = React.lazy(() => import(`./imgs/${icon}.svg`));
		iconComponentCache.set(icon, Component);
	}
	return Component;
}

const Icon = ({ className, icon, tagType, rotate, ...svgProps }: Props) => {
	const SvgComponent = getIconComponent(icon);

	const rotationStyle =
		rotate && rotate <= MAX_ROTATE ? { transform: `rotate(${rotate}deg)` } : {};

	// O Suspense fica DENTRO da div: assim o container (que tem min-width/min-height)
	// sempre renderiza e reserva o espaco do icone. Envolvendo a div inteira, o fallback
	// substituia o container por um texto solto, causando o "-" piscando e o pulo de layout.
	return (
		<div className={classNames(s.icon, className)}>
			<React.Suspense fallback={null}>
				<SvgComponent data-icon={icon} style={rotationStyle} {...svgProps} />
			</React.Suspense>

			{tagType && (
				<div
					className={classNames({
						[s.notification]: true,
						[s.new]: tagType === "new",
						[s.comingSoon]: tagType === "comingSoon",
					})}
				/>
			)}
		</div>
	);
};

export default Icon;
